import React from "react";

// `key` is passed to InspectionDetails as `tab` to decide which actions to show
export const requirementsTabs = [
  { key: "incomplete", label: "Incomplete Requirements" },
  { key: "overdue", label: "Overdue Requirements" },
  { key: "escalated", label: "Escalated Requirements" },
  { key: "submitted", label: "Submitted Requirements" },
  { key: "completed", label: "Completed Requirements" },
  { key: "archived", label: "Archived Surveys" },
];

const RequirementsTabs = ({ handleTabChange, currentTabIndex }) => {
  return (
    <div className="w-full">
      <div className="flex border-b border-gray-300">
        {requirementsTabs.map(({ key, label }, index) => (
          <button
            key={key}
            onClick={(e) => handleTabChange(e, index)}
            className={`py-2 px-4 text-xs font-medium uppercase focus:outline-none transition-colors ${
              currentTabIndex === index
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-600 hover:text-blue-600"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RequirementsTabs;
